import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem } from '@ng-bootstrap/ng-bootstrap';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { displayModalComponent } from '@myapp/features/widgets/models';
import { ICurrentUser } from '../../models';
import { UserService } from '../../services';
import { UserSettingsComponent } from '../user-settings/user-settings.component';
import { AvatarModule } from '@progress/kendo-angular-layout';
import { OktaWrapperService } from '../../../../../services/framework';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-user-card',
  templateUrl: './user-card.component.html',
  styleUrls: ['./user-card.component.scss'],
  standalone: true,
  imports: [NgbDropdown, NgbDropdownToggle, AvatarModule, NgbDropdownMenu, NgbDropdownItem]
})
export class UserCardComponent implements OnInit, OnDestroy {

  user: ICurrentUser;
  protected destroy$ = new Subject();

  constructor(protected userService: UserService
    , protected modalService: NgbModal
    , protected router: Router
    , private oktaWrapper: OktaWrapperService) {

    this.user = userService.emptyUser;
  }

  ngOnInit() {
    this.refreshUser();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public refreshUser() {
    this.userService.getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: ICurrentUser) => {
        this.user = user;
      });

  }

  public showProfileModal() {
  }

  public showSettingsModal() {
    const size = 'lg';
    const options = {
      title: "User Preferences", windowClass: "modal-preferences",
      showSave: true, showCancel: true, showCross: true, scrollable: false
    };
    displayModalComponent(UserSettingsComponent, size, options, this.modalService, []);
  }

  public logout() {
    this.oktaWrapper.logout();
    this.userService.clearLocalStorage();
  }
}
